export function isValidEmail(email: string) {
  if (!email) {
    return false
  }

  return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)
}

export function mailto(email: string) {
  return window.open(`mailto:${email}`, '_blank')
}
